import React, { useEffect } from 'react';
import { gsap } from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';
import "./hero.scss"
import SplitType from 'split-type';

function Hero() {
    //page title
    useEffect(() => {
        document.title = 'Aprameya Shankar';
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    });
    // mobile tab bar height adjustment
    useEffect(() => {
        const isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));
        if(isTouch && window.innerWidth<=500){
            document.querySelector("#hero-section").style.height = "calc(100vh - 50px)"
            document.querySelector(".hero-bottom").style.bottomPadding = "20px";
            document.querySelector(".black-pulldown").style.display = "none";
        }
    }, [])
    // black pulldown animation
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
        gsap.to(".black-pulldown", {
            scrollTrigger: {
                trigger: ".main-dark",
                scrub: true,
                // toggleActions: "restart none reverse pause"
            },
            scaleY: 2,
            // duration: 0.1,
        })
        gsap.to('.hero-section', {
            scrollTrigger: {
                trigger: ".main-dark",
                scrub: true,
            },
            autoAlpha: 0,
            opacity: 0
        })
    }, [])

    useEffect(() => {
        const split = new SplitType('.header')
        // const split2 = new SplitType('.sub-header')
        gsap.from(".h-a-1 .char", {
            duration: 0.3,
            y: '147',
            stagger: 0.06
        })
        gsap.from(".h-a-2 .char", {
            duration: 0.30,
            y: '147',
            stagger: 0.06,
            delay: 0.4
        })
        gsap.from(".h-a-3 .char", {
            duration: 0.30,
            y: '147',
            stagger: 0.06,
            delay: 0.95
        })
        gsap.from(".h-a-4 .char", {
            duration: 0.30,
            y: '147',
            stagger: 0.06,
            delay: 1.4
        })
        gsap.to(".s-h-1", {
            duration: 0.4,
            y: 0,
            delay: 2.1
        })
        gsap.to(".s-h-2", {
            duration: 0.4,
            y: 0,
            delay: 2.0
        })
        // gsap.to("#hero-section .img-div", {
        //     duration: 0.4,
        //     clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
        //     // x: 50
        // })
    }, [])

    return (
        <>
            <div className='black-pulldown'></div>
            <section id='hero-section' className='hero-section'>
                <div className='hero-top'>
                    <div className='content content-1'>
                        <h1 className='header'>
                            <span className='h-a-1'>web</span><br/>
                            <span className='h-a-2'>developer</span>
                            </h1>
                        {/* <p className='sub-header s-h-1'>
                            <span className='dash-span'></span>
                            front end addicted
                        </p> */}
                    </div>
                    <div className='img-div'></div>
                </div>
                <div className='hero-bottom'>
                    <div className='scroll-down'>
                        <span className='arrow'>↓</span>
                        <span>scroll</span>
                    </div>
                    <div className='content content-2'>
                        <a href="./assets/Aprameya S - Resume.pdf" name="Download Resume" download>
                            <p className='sub-header s-h-2'>
                                <span className='dash-span'></span>
                                Download Resume
                            </p>
                        </a>
                        <h1 className='header'>
                            <span className='h-a-3'>APRAMEYA
                            </span>
                        <br/>
                        <span className='h-a-4'>SHANKAR</span>
                        </h1> 
                    </div>
                </div>
            </section>
        </>
        
    )    
}
export default Hero;